import { reactive, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { toast, variant } from '@/core/helper/utility'
import { httpStatusCode } from '@/core/helper/httpStatusCode';
import { GetAll, Create, GetByGuid, Update } from "@/infrastructure/repositories/brandRepository"

export const useBrand = () => {
    var filter = reactive({});
    var brands = ref([]);
    var brand = reactive({
        guid: null,
        name: null,
    });
    var isLoading = ref(false);
    var isCreateLoading = ref(false);

    const brandRules = {
        name: { required },
    }

    const validate$ = useVuelidate(brandRules, brand, { $scope: false });

    const onCreateHandle = async () => {
        try {
            const isValid = await validate$.value.$validate();
            if(!isValid){
                return;
            }

            isCreateLoading.value = true;

            var response = await Create(brand);
            if(response.status == httpStatusCode.OK){
                toast({
                    variant: variant.success,
                    title: response.data.title,
                    body:  response.data.message
                });
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }
            isCreateLoading.value = false;
        } catch (error) {
            isCreateLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Brands',
                body: 'Could not get brand list, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    }

    const onUpdateHandle = async () => {
        try {
            const isValid = await validate$.value.$validate();
            if(!isValid){
                return;
            }

            isCreateLoading.value = true;

            var response = await Update(brand);
            if(response.status == httpStatusCode.OK){
                toast({
                    variant: variant.success,
                    title: response.data.title,
                    body:  response.data.message
                });
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }
            isCreateLoading.value = false;
        } catch (error) {
            isCreateLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Brands',
                body: 'Could not update brand, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    }

    const getBrands = async () => {
        try {
            isLoading.value = true;

            var response = await GetAll(filter);
            if(response.status == httpStatusCode.OK){
                brands.value = response.data.value;
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }
            isLoading.value = false;
        } catch (error) {
            isLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Brand',
                body: 'Could not get brand list, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    }

    const getBrandByGuid = async (guid) => {
        try {
            isLoading.value = true;

            var response = await GetByGuid(guid);

            if(response.status == httpStatusCode.OK){
                let currentBrand = response.data.value;

                brand.id = currentBrand.id;
                brand.guid = currentBrand.guid;
                brand.name = currentBrand.name;
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }
            isLoading.value = false;
        } catch (error) {
            isLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Brand',
                body: 'Could not get brand, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    }

    return {
        validate$,
        isLoading,
        isCreateLoading,
        brands,
        brand,
        getBrands,
        getBrandByGuid,
        onUpdateHandle,
        onCreateHandle
    }
}